var BrowseErrorPresenter;

module.exports = BrowseErrorPresenter = (function() {
  function BrowseErrorPresenter() {}

  BrowseErrorPresenter.prototype.toHash = function() {
    var aClose, aOpen, breakline, category, href, isClearanceSelected, isPriceFilterSelected, queryParams;
    href = window.location.href;
    aOpen = "<a href='" + href + "'>";
    aClose = "</a>";
    breakline = "<br>";
    queryParams = Groupon.Utils.unparam();
    isPriceFilterSelected = ((queryParams != null ? queryParams.minPrice : void 0) != null) || ((queryParams != null ? queryParams.maxPrice : void 0) != null);
    isClearanceSelected = (queryParams != null ? queryParams.discount : void 0) === "gg-clearance";
    if (isPriceFilterSelected) {
      category = (queryParams != null ? queryParams.category : void 0) || 'all';
      href = "/goods?category=" + category;
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.price_range_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    } else if (isClearanceSelected) {
      href = "/goods?category=all&discount=gg-clearance";
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.clearance_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        })
      };
    } else {
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    }
  };

  return BrowseErrorPresenter;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9wcmVzZW50ZXJzL2Vycm9yLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FkY2FiYWxsZXJvL25hcGlzdHJhbm8vYnVpbGQvMTQ5MjQ2Nzk3NTM3OS0zNzk1Mi9zdGFnaW5nLTIwMTcuMDQuMTdfMjIuMTUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvcHJlc2VudGVycy9lcnJvci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFNLENBQUMsT0FBUCxHQUF1Qjs7O2lDQUNyQixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQU8sTUFBTSxDQUFDLFFBQVEsQ0FBQztJQUN2QixLQUFBLEdBQVEsV0FBQSxHQUFZLElBQVosR0FBaUI7SUFDekIsTUFBQSxHQUFTO0lBQ1QsU0FBQSxHQUFZO0lBQ1osV0FBQSxHQUFjLE9BQU8sQ0FBQyxLQUFLLENBQUMsT0FBZCxDQUFBO0lBRWQscUJBQUEsR0FBd0IsK0RBQUEsSUFBMEI7SUFDbEQsbUJBQUEsMEJBQXNCLFdBQVcsQ0FBRSxrQkFBYixLQUF5QjtJQUMvQyxJQUFHLHFCQUFIO01BQ0UsUUFBQSwwQkFBVyxXQUFXLENBQUUsa0JBQWIsSUFBeUI7TUFDcEMsSUFBQSxHQUFPLGtCQUFBLEdBQW1CO01BQzFCLEtBQUEsR0FBUSxXQUFBLEdBQVksSUFBWixHQUFpQjthQUN6QjtRQUFBLG9CQUFBLEVBQXNCLElBQUksQ0FBQyxTQUFMLENBQWUsMkRBQWYsQ0FBdEI7UUFDQSx3QkFBQSxFQUEwQixJQUFJLENBQUMsU0FBTCxDQUFlLDJFQUFmLEVBQTRGO1VBQUUsT0FBQSxLQUFGO1VBQVMsUUFBQSxNQUFUO1NBQTVGLENBRDFCO1FBRUEsd0JBQUEsRUFBMEIsSUFBSSxDQUFDLFNBQUwsQ0FBZSwrREFBZixFQUFnRjtVQUFFLFdBQUEsU0FBRjtTQUFoRixDQUYxQjtRQUpGO0tBQUEsTUFPSyxJQUFHLG1CQUFIO01BQ0gsSUFBQSxHQUFPO01BQ1AsS0FBQSxHQUFRLFdBQUEsR0FBWSxJQUFaLEdBQWlCO2FBQ3pCO1FBQUEsb0JBQUEsRUFBc0IsSUFBSSxDQUFDLFNBQUwsQ0FBZSwyREFBZixDQUF0QjtRQUNBLHdCQUFBLEVBQTBCLElBQUksQ0FBQyxTQUFMLENBQWUseUVBQWYsRUFBMEY7VUFBRSxPQUFBLEtBQUY7VUFBUyxRQUFBLE1BQVQ7U0FBMUYsQ0FEMUI7UUFIRztLQUFBLE1BQUE7YUFNSDtRQUFBLG9CQUFBLEVBQXNCLElBQUksQ0FBQyxTQUFMLENBQWUsMkRBQWYsQ0FBdEI7UUFDQSx3QkFBQSxFQUEwQixJQUFJLENBQUMsU0FBTCxDQUFlLCtEQUFmLEVBQWdGO1VBQUUsT0FBQSxLQUFGO1VBQVMsUUFBQSxNQUFUO1NBQWhGLENBRDFCO1FBRUEsd0JBQUEsRUFBMEIsSUFBSSxDQUFDLFNBQUwsQ0FBZSwrREFBZixFQUFnRjtVQUFFLFdBQUEsU0FBRjtTQUFoRixDQUYxQjtRQU5HOztFQWhCQyJ9
